import { HandHeartIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const ReceivedLike = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <HandHeartIcon size={Sizes[size]} {...rest} color={fill} />;
};

ReceivedLike.displayName = 'ReceivedLike';
